import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'orderDataField',
  standalone: true,
  pure: false // Hacer el pipe impuro para que se actualice con cambios de idioma
})
export class OrderDataFieldPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(field: string): string {
    if (!field) return '';

    // Intentar con el campo tal cual
    let translationKey = `ORDER_DATA_FIELDS.${field}`;
    let translated = this.translateService.instant(translationKey);
    
    if (translated !== translationKey) {
      return translated;
    }

    // Intentar con la primera letra en mayúscula
    const capitalizedField = field.charAt(0).toUpperCase() + field.slice(1);
    translationKey = `ORDER_DATA_FIELDS.${capitalizedField}`;
    translated = this.translateService.instant(translationKey);
    
    if (translated !== translationKey) {
      return translated;
    }

    // Intentar con todo en minúsculas
    const lowerField = field.toLowerCase();
    translationKey = `ORDER_DATA_FIELDS.${lowerField}`;
    translated = this.translateService.instant(translationKey);
    
    if (translated !== translationKey) {
      return translated;
    }

    // Si no se encuentra traducción, devolver el campo original
    return field;
  }
}